import React from 'react';

// Template components for Instagram posts
export const InstagramTemplate = ({ 
  type = 'welcome',
  title = '',
  subtitle = '',
  content = [],
  icons = [],
  bgStyle = 'gradient',
  accentColor = '#3B82F6'
}) => {
  const size = 1080;
  
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="mainGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#3B82F6', stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: '#6366F1', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#9333EA', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="subtleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#EFF6FF', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#F5F3FF', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Background */}
      {bgStyle === 'gradient' ? (
        <rect width={size} height={size} fill="url(#mainGradient)" />
      ) : bgStyle === 'subtle' ? (
        <rect width={size} height={size} fill="url(#subtleGradient)" />
      ) : (
        <rect width={size} height={size} fill="white" />
      )}
      
      {/* Content container */}
      <g>
        {/* Logo at top */}
        <text
          x={size / 2}
          y={150}
          fontSize="60"
          fontFamily="'Inter', sans-serif"
          fontWeight="700"
          fill={bgStyle === 'gradient' ? 'white' : 'url(#mainGradient)'}
          textAnchor="middle"
        >
          Trabadju
        </text>
        <text
          x={size / 2}
          y={190}
          fontSize="18"
          fontFamily="'Inter', sans-serif"
          fontWeight="500"
          fill={bgStyle === 'gradient' ? 'rgba(255,255,255,0.8)' : '#6B7280'}
          textAnchor="middle"
          letterSpacing="3"
        >
          CABO VERDE
        </text>
        
        {/* Main title */}
        {title && (
          <text
            x={size / 2}
            y={350}
            fontSize="72"
            fontFamily="'Inter', sans-serif"
            fontWeight="800"
            fill={bgStyle === 'gradient' ? 'white' : '#1F2937'}
            textAnchor="middle"
          >
            {title}
          </text>
        )}
        
        {/* Subtitle */}
        {subtitle && (
          <text
            x={size / 2}
            y={420}
            fontSize="32"
            fontFamily="'Inter', sans-serif"
            fontWeight="400"
            fill={bgStyle === 'gradient' ? 'rgba(255,255,255,0.9)' : '#4B5563'}
            textAnchor="middle"
          >
            {subtitle}
          </text>
        )}
        
        {/* Content items */}
        {content.map((item, index) => (
          <g key={index}>
            <text
              x={180}
              y={500 + (index * 70)}
              fontSize="28"
              fontFamily="'Inter', sans-serif"
              fontWeight="600"
              fill={bgStyle === 'gradient' ? 'white' : '#1F2937'}
            >
              {item}
            </text>
          </g>
        ))}
        
        {/* Footer */}
        <text
          x={size / 2}
          y={950}
          fontSize="32"
          fontFamily="'Inter', sans-serif"
          fontWeight="700"
          fill={bgStyle === 'gradient' ? 'white' : 'url(#mainGradient)'}
          textAnchor="middle"
        >
          trabadju.cv
        </text>
      </g>
    </svg>
  );
};

// Template 1: Welcome Post
export const WelcomeTemplate = () => (
  <svg width="1080" height="1080" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#3B82F6' }} />
        <stop offset="50%" style={{ stopColor: '#6366F1' }} />
        <stop offset="100%" style={{ stopColor: '#9333EA' }} />
      </linearGradient>
    </defs>
    <rect width="1080" height="1080" fill="url(#grad1)" />
    
    {/* Decorative circles */}
    <circle cx="150" cy="150" r="80" fill="rgba(255,255,255,0.1)" />
    <circle cx="930" cy="930" r="120" fill="rgba(255,255,255,0.1)" />
    
    {/* Content */}
    <text x="540" y="200" fontSize="70" fontWeight="800" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Trabadju
    </text>
    <text x="540" y="250" fontSize="20" fontWeight="500" fill="rgba(255,255,255,0.8)" textAnchor="middle" fontFamily="Inter, sans-serif" letterSpacing="4">
      CABO VERDE
    </text>
    
    <text x="540" y="420" fontSize="68" fontWeight="800" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      BEM-VINDOS
    </text>
    <text x="540" y="490" fontSize="36" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      🚀
    </text>
    
    <text x="540" y="600" fontSize="32" fontWeight="600" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      A Plataforma de Emprego
    </text>
    <text x="540" y="650" fontSize="32" fontWeight="600" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      100% Cabo-Verdiana
    </text>
    
    <text x="540" y="780" fontSize="28" fontWeight="400" fill="rgba(255,255,255,0.85)" textAnchor="middle" fontFamily="Inter, sans-serif">
      Conectamos Empresas e Talentos
    </text>
    
    <rect x="340" y="840" width="400" height="80" rx="40" fill="white" />
    <text x="540" y="890" fontSize="32" fontWeight="700" fill="#6366F1" textAnchor="middle" fontFamily="Inter, sans-serif">
      Comece Agora →
    </text>
    
    <text x="540" y="1000" fontSize="28" fontWeight="600" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      trabadju.cv
    </text>
  </svg>
);

// Template 2: Para Candidatos
export const CandidateTemplate = () => (
  <svg width="1080" height="1080" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#EFF6FF' }} />
        <stop offset="100%" style={{ stopColor: '#F5F3FF' }} />
      </linearGradient>
    </defs>
    <rect width="1080" height="1080" fill="url(#grad2)" />
    
    {/* Header */}
    <text x="540" y="150" fontSize="60" fontWeight="800" fill="#3B82F6" textAnchor="middle" fontFamily="Inter, sans-serif">
      Trabadju
    </text>
    <text x="540" y="190" fontSize="18" fontWeight="500" fill="#6B7280" textAnchor="middle" fontFamily="Inter, sans-serif" letterSpacing="3">
      CABO VERDE
    </text>
    
    {/* Icon */}
    <circle cx="540" cy="320" r="80" fill="#3B82F6" opacity="0.2" />
    <text x="540" y="345" fontSize="70" textAnchor="middle">💼</text>
    
    {/* Title */}
    <text x="540" y="480" fontSize="56" fontWeight="800" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      Para Candidatos
    </text>
    
    {/* Features */}
    <text x="200" y="580" fontSize="32" fontWeight="600" fill="#1F2937" fontFamily="Inter, sans-serif">
      ✅ Registo GRATUITO
    </text>
    <text x="200" y="650" fontSize="32" fontWeight="600" fill="#1F2937" fontFamily="Inter, sans-serif">
      ✅ Perfil Completo
    </text>
    <text x="200" y="720" fontSize="32" fontWeight="600" fill="#1F2937" fontFamily="Inter, sans-serif">
      ✅ Upload de CV
    </text>
    <text x="200" y="790" fontSize="32" fontWeight="600" fill="#1F2937" fontFamily="Inter, sans-serif">
      ✅ Candidatura 1 Clique
    </text>
    
    {/* CTA */}
    <rect x="240" y="880" width="600" height="90" rx="45" fill="#3B82F6" />
    <text x="540" y="935" fontSize="36" fontWeight="700" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Encontre Sua Vaga →
    </text>
    
    <text x="540" y="1020" fontSize="28" fontWeight="600" fill="#3B82F6" textAnchor="middle" fontFamily="Inter, sans-serif">
      trabadju.cv
    </text>
  </svg>
);

// Template 3: Para Empresas
export const CompanyTemplate = () => (
  <svg width="1080" height="1080" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#1F2937' }} />
        <stop offset="100%" style={{ stopColor: '#374151' }} />
      </linearGradient>
    </defs>
    <rect width="1080" height="1080" fill="url(#grad3)" />
    
    {/* Decorative */}
    <rect x="100" y="100" width="880" height="880" rx="40" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="2" />
    
    {/* Header */}
    <text x="540" y="180" fontSize="60" fontWeight="800" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Trabadju
    </text>
    <text x="540" y="220" fontSize="18" fontWeight="500" fill="rgba(255,255,255,0.7)" textAnchor="middle" fontFamily="Inter, sans-serif" letterSpacing="3">
      CABO VERDE
    </text>
    
    {/* Icon */}
    <text x="540" y="340" fontSize="80" textAnchor="middle">🏢</text>
    
    {/* Title */}
    <text x="540" y="450" fontSize="56" fontWeight="800" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Para Empresas
    </text>
    
    {/* Pricing */}
    <rect x="180" y="520" width="720" height="280" rx="20" fill="rgba(255,255,255,0.1)" />
    
    <text x="540" y="580" fontSize="28" fontWeight="600" fill="#60A5FA" textAnchor="middle" fontFamily="Inter, sans-serif">
      BÁSICO - GRÁTIS
    </text>
    <text x="540" y="620" fontSize="24" fontWeight="400" fill="rgba(255,255,255,0.8)" textAnchor="middle" fontFamily="Inter, sans-serif">
      Depois apenas 500 CVE/mês
    </text>
    
    <text x="540" y="690" fontSize="28" fontWeight="600" fill="#60A5FA" textAnchor="middle" fontFamily="Inter, sans-serif">
      STANDARD - 2.500 CVE
    </text>
    <text x="540" y="730" fontSize="24" fontWeight="400" fill="rgba(255,255,255,0.8)" textAnchor="middle" fontFamily="Inter, sans-serif">
      Até 5 vagas ativas
    </text>
    
    <text x="540" y="800" fontSize="28" fontWeight="600" fill="#60A5FA" textAnchor="middle" fontFamily="Inter, sans-serif">
      UNLIMITED - 6.000 CVE
    </text>
    
    {/* CTA */}
    <rect x="240" y="880" width="600" height="90" rx="45" fill="white" />
    <text x="540" y="935" fontSize="36" fontWeight="700" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      Publique Agora →
    </text>
    
    <text x="540" y="1020" fontSize="28" fontWeight="600" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      trabadju.cv
    </text>
  </svg>
);

// Template 4: Estatísticas
export const StatisticsTemplate = () => (
  <svg width="1080" height="1080" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="grad4" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#F0F9FF' }} />
        <stop offset="100%" style={{ stopColor: '#EDE9FE' }} />
      </linearGradient>
    </defs>
    <rect width="1080" height="1080" fill="url(#grad4)" />
    
    {/* Header */}
    <text x="540" y="120" fontSize="50" fontWeight="800" fill="#3B82F6" textAnchor="middle" fontFamily="Inter, sans-serif">
      Trabadju
    </text>
    <text x="540" y="160" fontSize="16" fontWeight="500" fill="#6B7280" textAnchor="middle" fontFamily="Inter, sans-serif" letterSpacing="3">
      CABO VERDE
    </text>
    
    {/* Title */}
    <text x="540" y="280" fontSize="50" fontWeight="800" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      Sabias que...
    </text>
    
    {/* Stat 1 */}
    <circle cx="540" cy="450" r="140" fill="#3B82F6" opacity="0.1" />
    <text x="540" y="440" fontSize="100" fontWeight="900" fill="#3B82F6" textAnchor="middle" fontFamily="Inter, sans-serif">
      70%
    </text>
    <text x="540" y="490" fontSize="28" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      dos cabo-verdianos
    </text>
    <text x="540" y="530" fontSize="28" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      procuram emprego online
    </text>
    
    {/* Divider */}
    <line x1="200" y1="620" x2="880" y2="620" stroke="#D1D5DB" strokeWidth="2" />
    
    {/* Stat 2 */}
    <text x="540" y="700" fontSize="42" fontWeight="800" fill="#6366F1" textAnchor="middle" fontFamily="Inter, sans-serif">
      3 em cada 4 empresas
    </text>
    <text x="540" y="750" fontSize="26" fontWeight="400" fill="#4B5563" textAnchor="middle" fontFamily="Inter, sans-serif">
      têm dificuldade em encontrar talentos
    </text>
    
    {/* CTA */}
    <rect x="200" y="840" width="680" height="90" rx="45" fill="#3B82F6" />
    <text x="540" y="895" fontSize="34" fontWeight="700" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      O Trabadju resolve isso! 🚀
    </text>
    
    <text x="540" y="1000" fontSize="28" fontWeight="600" fill="#3B82F6" textAnchor="middle" fontFamily="Inter, sans-serif">
      trabadju.cv
    </text>
  </svg>
);

// Template 5 Slide 1: Tutorial - Passo 1
export const TutorialSlide1 = () => (
  <svg width="1080" height="1080" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="grad5" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#3B82F6' }} />
        <stop offset="100%" style={{ stopColor: '#8B5CF6' }} />
      </linearGradient>
    </defs>
    <rect width="1080" height="1080" fill="url(#grad5)" />
    
    {/* Slide indicator */}
    <circle cx="490" cy="100" r="8" fill="white" />
    <circle cx="540" cy="100" r="8" fill="rgba(255,255,255,0.5)" />
    <circle cx="590" cy="100" r="8" fill="rgba(255,255,255,0.5)" />
    
    <text x="540" y="220" fontSize="60" fontWeight="800" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Como Candidatar-se
    </text>
    <text x="540" y="280" fontSize="32" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      em 3 Passos Simples
    </text>
    
    {/* Step number */}
    <circle cx="540" cy="480" r="120" fill="white" />
    <text x="540" y="520" fontSize="140" fontWeight="900" fill="#3B82F6" textAnchor="middle" fontFamily="Inter, sans-serif">
      1
    </text>
    
    {/* Step description */}
    <text x="540" y="700" fontSize="48" fontWeight="700" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Registe-se
    </text>
    <text x="540" y="760" fontSize="32" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      Gratuitamente em
    </text>
    <text x="540" y="810" fontSize="32" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      trabadju.cv
    </text>
    
    <text x="540" y="950" fontSize="28" fontWeight="600" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Deslize para o próximo passo →
    </text>
  </svg>
);

// Template 5 Slide 2: Tutorial - Passo 2
export const TutorialSlide2 = () => (
  <svg width="1080" height="1080" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="grad5b" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#3B82F6' }} />
        <stop offset="100%" style={{ stopColor: '#8B5CF6' }} />
      </linearGradient>
    </defs>
    <rect width="1080" height="1080" fill="url(#grad5b)" />
    
    <circle cx="490" cy="100" r="8" fill="rgba(255,255,255,0.5)" />
    <circle cx="540" cy="100" r="8" fill="white" />
    <circle cx="590" cy="100" r="8" fill="rgba(255,255,255,0.5)" />
    
    <text x="540" y="220" fontSize="60" fontWeight="800" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Como Candidatar-se
    </text>
    <text x="540" y="280" fontSize="32" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      em 3 Passos Simples
    </text>
    
    <circle cx="540" cy="480" r="120" fill="white" />
    <text x="540" y="520" fontSize="140" fontWeight="900" fill="#3B82F6" textAnchor="middle" fontFamily="Inter, sans-serif">
      2
    </text>
    
    <text x="540" y="700" fontSize="48" fontWeight="700" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Complete o Perfil
    </text>
    <text x="540" y="760" fontSize="32" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      Upload de CV,
    </text>
    <text x="540" y="810" fontSize="32" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      Carta de Motivação
    </text>
    
    <text x="540" y="950" fontSize="28" fontWeight="600" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Deslize para o próximo passo →
    </text>
  </svg>
);

// Template 5 Slide 3: Tutorial - Passo 3
export const TutorialSlide3 = () => (
  <svg width="1080" height="1080" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="grad5c" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#3B82F6' }} />
        <stop offset="100%" style={{ stopColor: '#8B5CF6' }} />
      </linearGradient>
    </defs>
    <rect width="1080" height="1080" fill="url(#grad5c)" />
    
    <circle cx="490" cy="100" r="8" fill="rgba(255,255,255,0.5)" />
    <circle cx="540" cy="100" r="8" fill="rgba(255,255,255,0.5)" />
    <circle cx="590" cy="100" r="8" fill="white" />
    
    <text x="540" y="220" fontSize="60" fontWeight="800" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Como Candidatar-se
    </text>
    <text x="540" y="280" fontSize="32" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      em 3 Passos Simples
    </text>
    
    <circle cx="540" cy="480" r="120" fill="white" />
    <text x="540" y="520" fontSize="140" fontWeight="900" fill="#3B82F6" textAnchor="middle" fontFamily="Inter, sans-serif">
      3
    </text>
    
    <text x="540" y="700" fontSize="48" fontWeight="700" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Candidate-se!
    </text>
    <text x="540" y="760" fontSize="32" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      Procure vagas e
    </text>
    <text x="540" y="810" fontSize="32" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      candidate-se com 1 clique! ✨
    </text>
    
    <rect x="280" y="900" width="520" height="70" rx="35" fill="white" />
    <text x="540" y="945" fontSize="32" fontWeight="700" fill="#3B82F6" textAnchor="middle" fontFamily="Inter, sans-serif">
      É assim tão fácil! 🎉
    </text>
  </svg>
);

// Template 6: Setores
export const SectorsTemplate = () => (
  <svg width="1080" height="1080" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
    <rect width="1080" height="1080" fill="white" />
    
    <text x="540" y="100" fontSize="50" fontWeight="800" fill="#3B82F6" textAnchor="middle" fontFamily="Inter, sans-serif">
      Trabadju
    </text>
    
    <text x="540" y="220" fontSize="56" fontWeight="800" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      Vagas em TODAS
    </text>
    <text x="540" y="280" fontSize="56" fontWeight="800" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      as Áreas!
    </text>
    
    {/* Grid of sectors */}
    <rect x="100" y="350" width="400" height="100" rx="15" fill="#EFF6FF" />
    <text x="300" y="415" fontSize="32" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      💻 Tecnologia
    </text>
    
    <rect x="580" y="350" width="400" height="100" rx="15" fill="#F0F9FF" />
    <text x="780" y="415" fontSize="32" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      🏨 Turismo
    </text>
    
    <rect x="100" y="480" width="400" height="100" rx="15" fill="#EDE9FE" />
    <text x="300" y="545" fontSize="32" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      🏪 Vendas
    </text>
    
    <rect x="580" y="480" width="400" height="100" rx="15" fill="#FEF3C7" />
    <text x="780" y="545" fontSize="32" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      🏦 Finanças
    </text>
    
    <rect x="100" y="610" width="400" height="100" rx="15" fill="#ECFDF5" />
    <text x="300" y="675" fontSize="32" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      🏗️ Construção
    </text>
    
    <rect x="580" y="610" width="400" height="100" rx="15" fill="#FEE2E2" />
    <text x="780" y="675" fontSize="32" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      🏥 Saúde
    </text>
    
    <rect x="100" y="740" width="400" height="100" rx="15" fill="#F3E8FF" />
    <text x="300" y="805" fontSize="32" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      📚 Educação
    </text>
    
    <rect x="580" y="740" width="400" height="100" rx="15" fill="#DBEAFE" />
    <text x="780" y="805" fontSize="32" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      📱 Marketing
    </text>
    
    <text x="540" y="920" fontSize="36" fontWeight="700" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      Qual é a sua área? 👇
    </text>
    
    <text x="540" y="1000" fontSize="28" fontWeight="600" fill="#3B82F6" textAnchor="middle" fontFamily="Inter, sans-serif">
      trabadju.cv
    </text>
  </svg>
);

// Template 7: Dicas de Carreira
export const CareerTipsTemplate = () => (
  <svg width="1080" height="1080" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="grad7" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#FEF3C7' }} />
        <stop offset="100%" style={{ stopColor: '#FED7AA' }} />
      </linearGradient>
    </defs>
    <rect width="1080" height="1080" fill="url(#grad7)" />
    
    <text x="540" y="150" fontSize="70" textAnchor="middle">💡</text>
    
    <text x="540" y="260" fontSize="52" fontWeight="800" fill="#92400E" textAnchor="middle" fontFamily="Inter, sans-serif">
      Dica de Carreira
    </text>
    
    <rect x="120" y="320" width="840" height="400" rx="30" fill="white" opacity="0.9" />
    
    <text x="540" y="420" fontSize="42" fontWeight="700" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      "Um CV bem estruturado
    </text>
    <text x="540" y="480" fontSize="42" fontWeight="700" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      aumenta em 60%
    </text>
    <text x="540" y="540" fontSize="42" fontWeight="700" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      suas chances de ser
    </text>
    <text x="540" y="600" fontSize="42" fontWeight="700" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      chamado para entrevista!"
    </text>
    
    <text x="540" y="660" fontSize="24" fontWeight="400" fill="#6B7280" textAnchor="middle" fontFamily="Inter, sans-serif">
      - Especialistas em RH
    </text>
    
    <text x="540" y="820" fontSize="36" fontWeight="700" fill="#92400E" textAnchor="middle" fontFamily="Inter, sans-serif">
      ✅ No Trabadju, carregue
    </text>
    <text x="540" y="870" fontSize="36" fontWeight="700" fill="#92400E" textAnchor="middle" fontFamily="Inter, sans-serif">
      o seu CV e destaque-se!
    </text>
    
    <text x="540" y="1000" fontSize="28" fontWeight="600" fill="#92400E" textAnchor="middle" fontFamily="Inter, sans-serif">
      trabadju.cv
    </text>
  </svg>
);

// Template 8: Call to Action
export const CTATemplate = () => (
  <svg width="1080" height="1080" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="grad8" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#DC2626' }} />
        <stop offset="100%" style={{ stopColor: '#EA580C' }} />
      </linearGradient>
    </defs>
    <rect width="1080" height="1080" fill="url(#grad8)" />
    
    <text x="540" y="180" fontSize="80" textAnchor="middle">📣</text>
    
    <text x="540" y="320" fontSize="64" fontWeight="900" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      ATENÇÃO
    </text>
    <text x="540" y="400" fontSize="64" fontWeight="900" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      EMPRESAS!
    </text>
    
    <text x="540" y="520" fontSize="38" fontWeight="600" fill="rgba(255,255,255,0.95)" textAnchor="middle" fontFamily="Inter, sans-serif">
      Está a recrutar?
    </text>
    
    <rect x="150" y="580" width="780" height="300" rx="25" fill="white" />
    
    <text x="540" y="650" fontSize="44" fontWeight="800" fill="#DC2626" textAnchor="middle" fontFamily="Inter, sans-serif">
      🎁 Oferta de Lançamento
    </text>
    
    <text x="540" y="730" fontSize="36" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      ✨ 30 dias GRÁTIS
    </text>
    <text x="540" y="790" fontSize="36" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      ✨ Sem cartão de crédito
    </text>
    <text x="540" y="850" fontSize="36" fontWeight="600" fill="#1F2937" textAnchor="middle" fontFamily="Inter, sans-serif">
      ✨ Sem compromisso
    </text>
    
    <rect x="250" y="940" width="580" height="80" rx="40" fill="white" />
    <text x="540" y="990" fontSize="38" fontWeight="700" fill="#DC2626" textAnchor="middle" fontFamily="Inter, sans-serif">
      Comece Agora →
    </text>
  </svg>
);

// Template 9: Comunidade
export const CommunityTemplate = () => (
  <svg width="1080" height="1080" viewBox="0 0 1080 1080" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="grad9" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#1E40AF' }} />
        <stop offset="50%" style={{ stopColor: '#7C3AED' }} />
        <stop offset="100%" style={{ stopColor: '#DB2777' }} />
      </linearGradient>
    </defs>
    <rect width="1080" height="1080" fill="url(#grad9)" />
    
    <text x="540" y="200" fontSize="90" textAnchor="middle">🇨🇻</text>
    
    <text x="540" y="350" fontSize="58" fontWeight="800" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      Feito em Cabo Verde,
    </text>
    <text x="540" y="420" fontSize="58" fontWeight="800" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      para Cabo Verde!
    </text>
    
    <rect x="120" y="500" width="840" height="280" rx="20" fill="rgba(255,255,255,0.15)" />
    
    <text x="540" y="570" fontSize="34" fontWeight="600" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      🌟 Nossa missão:
    </text>
    <text x="540" y="630" fontSize="30" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      Conectar cada talento
    </text>
    <text x="540" y="675" fontSize="30" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      à oportunidade certa
    </text>
    <text x="540" y="720" fontSize="30" fontWeight="400" fill="rgba(255,255,255,0.9)" textAnchor="middle" fontFamily="Inter, sans-serif">
      Ajudar empresas locais a crescer
    </text>
    
    <text x="540" y="860" fontSize="42" fontWeight="700" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      🙌 Partilhe com alguém
    </text>
    <text x="540" y="920" fontSize="42" fontWeight="700" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      que procura emprego!
    </text>
    
    <text x="540" y="1010" fontSize="32" fontWeight="600" fill="white" textAnchor="middle" fontFamily="Inter, sans-serif">
      trabadju.cv • info@trabadju.cv
    </text>
  </svg>
);

export default {
  WelcomeTemplate,
  CandidateTemplate,
  CompanyTemplate,
  StatisticsTemplate,
  TutorialSlide1,
  TutorialSlide2,
  TutorialSlide3,
  SectorsTemplate,
  CareerTipsTemplate,
  CTATemplate,
  CommunityTemplate
};
